import { render, staticRenderFns } from "./tipologieDistributore.vue?vue&type=template&id=742c7544&"
import script from "./tipologieDistributore.vue.ts?vue&type=script&lang=ts&"
export * from "./tipologieDistributore.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports